import TableComponent from "./Table";

export default TableComponent